import { Box, Checkbox, FormControlLabel, Grid, TextField, Typography } from "@mui/material";
import React from "react";

export default function PaySlipFooter({handleInputChange,formData}) {

  
  return (

    <Grid container spacing={2} sx={{ mt: 3, display: "flex", alignItems: "center", justifyContent: "center" }}>
 
    <Grid item xs={12} md={8} sm={8}>
      <TextField
        label="Footer 1"
        name="footer1"
        fullWidth
        onChange={handleInputChange}
        multiline
        className=" inputRounded "
        value={formData.footer1}
        required
      />
    </Grid>
    <Grid item xs={12} md={8} sm={8}>
      <TextField
        label="Footer 2"
        name="footer2"
        value={formData.footer2}
        fullWidth
        onChange={handleInputChange}
        multiline
        className=" inputRounded "
        required
      />
    </Grid>
    <Grid item xs={12} md={8} sm={8}>
      <TextField
        label="Footer 3"
        name="footer3"
        value={formData.footer3}
        fullWidth
        onChange={handleInputChange}
        multiline
        className=" inputRounded "
        required
      />
    </Grid>
  </Grid>
  
  );
}
